<template>
  <div class="wrap">
    <div class="d-flex justify-content-center align-items-center" style="gap: .85rem">
      <span class="column-action-button bg-light d-flex justify-content-center align-items-center border" @click="$emit('details', { component: 'AreaDetails', value:value })">
          <i class="mdi mdi-eye-off-outline" v-if="!showDetails" ></i>
          <i class="mdi mdi-eye-outline" v-if="showDetails" ></i>
        </span>
      <div class="ml-2">
        {{value.name}}
      </div>
      <div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    showDetails: {
      type: Boolean,
      required: false
    }
  }
}
</script>
<style lang="sass" scoped>
.wrap
  display: flex
  align-items: center
button
  margin-right: 5px
.wrap-badges
  float: right
  display: flex
  justify-content: center
  align-items: center
.column-action-button
  width: 27px
  height: 27px
  border-radius: 50%
  padding: 4px
</style>
